/*@ngInject*/
const RuleActionController = function ($rootScope, $element, localization, umStudioConstant) {
    $element.addClass('ruleAction');

    localization.getTranslations().then(function (translations) {

        this.getActionType = function () {
            var type,
                objectUri = this.ruleAction.objectUri;

            if (_.lastIndexOf(objectUri, '/') > 0) {
                type = objectUri.substr(1, _.lastIndexOf(objectUri, '/') - 1);
            } else {
                type = objectUri.substr(1);
            }
            return type;
        };

        this.deleteAction = function () {
            this.onDeleteSubAction({subAction: this.ruleAction});
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.onRawActionChange = function () {
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

    }.bind(this));
};


angular.module('umCore')
    .controller('ruleActionController', RuleActionController);
